// Rarities (Uranus): a letter whose base value, as printed, is high scores
// more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const rarities: AlignmentDef = {
  id: 'rarities',
  planet: 'uranus',
  name: 'Rarities',
  text: () => `Letters with a base value of ${N.raritiesBase} or more score +${N.raritiesPercent}%.`,
  starPercent: (star) => (star.base >= N.raritiesBase ? N.raritiesPercent : 0),
};
